import Vue from 'vue'
import Router from 'vue-router'
import userRoutes from './user_router'
import produceRoutes from './produce_router'
import reportRoutes from './report_router'
import pruchaseRoutes from './purchase_router'
import financeRoutes from './finance_router'
import saleRoutes from './sale_router'
import experimentRoutes from './experiment_router'

const login = () => import('../views/common/login.vue')
const notFound = () => import('../views/common/notFound.vue')
const layout = () => import('../views/common/layout.vue')
const profile = () => import('../views/user/users/profile.vue')
const dashboard = () => import('../views/common/dashboard/index.vue')
const drillInfo = () => import('../views/common/drill_info/index.vue')

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err);
};

export const constantRoutes = [
	{
		path: '/',
		component: layout,
		redirect: '/dashboard',
		children: userRoutes.concat(produceRoutes).concat(reportRoutes).concat(pruchaseRoutes).concat(financeRoutes).concat(saleRoutes).concat(experimentRoutes)
	},
	{
		path: '/login',
		component: login,
		meta: { title: '登录' }
	},
	{
		path: '/dashboard',
		component: dashboard,
		meta: { title: '首页' }
	},
	{
		path: '/drill_info/:serial_number',
		component: drillInfo,
		meta: { title: '钻头详情' }
	},
	{
		path: '/users/profile',
		component: profile,
		meta: { title: '信息修改' }
	},
	{
		path: '*',
		component: notFound,
		meta: { title: '404' }
	}
]

const createRouter = () => new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: constantRoutes,
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if (savedPosition) {
					resolve(savedPosition)
					return
				}
				resolve({ x: 0, y: 0 })
			}, 500)
		})
	}
})

const router = createRouter()

export default router
